(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jugre-home-catalog"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeCatalog = (root) => {
      if (root.dataset.jugreReady === 'true') return;
      root.dataset.jugreReady = 'true';

      const filters = [...root.querySelectorAll('[data-jugre-filter]')];
      const groups = [...root.querySelectorAll('[data-jugre-group]')];
      const products = [...root.querySelectorAll('[data-jugre-product]')];
      const count = root.querySelector('[data-jugre-count]');
      const productsLabel = count ? count.textContent.trim().replace(/^\d+\s*/, '') : '';

      const applyFilter = (filter) => {
        let visibleCount = 0;

        products.forEach((product) => {
          const visible = filter === 'all' || product.dataset.jugreCategory === filter;
          product.hidden = !visible;
          if (visible) visibleCount += 1;
        });

        filters.forEach((control) => {
          const active = control.dataset.jugreFilter === filter;
          control.classList.toggle('is-active', active);
          if (control.hasAttribute('aria-pressed')) {
            control.setAttribute('aria-pressed', String(active));
          }
        });

        groups.forEach((group) => {
          const summary = group.querySelector('summary');
          group.classList.toggle('is-active', summary?.dataset.jugreFilter === filter);
        });

        if (count) count.textContent = `${visibleCount} ${productsLabel}`;
      };

      filters.forEach((control) => {
        control.addEventListener('click', () => {
          if (control.tagName === 'SUMMARY') {
            groups.forEach((group) => {
              if (group !== control.parentElement) group.open = false;
            });
          }

          const update = () => applyFilter(control.dataset.jugreFilter);
          if (document.startViewTransition) {
            document.startViewTransition(update);
          } else {
            update();
          }
        });
      });
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-jugre-catalog]').forEach(initializeCatalog);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jugre-home-products"]) return;
  try {
    
  function placeJugreHomeProducts() {
    const productSection = document.querySelector('[data-jugre-home-products]');
    if (!productSection) return;

    const sampleProductSection = document.querySelector('[id*="product_list_themegen"]');
    if (sampleProductSection) {
      sampleProductSection.insertAdjacentElement('beforebegin', productSection);
      sampleProductSection.hidden = true;
      return;
    }

    const marquee = document.querySelector('[id*="marquee"]');
    if (marquee && marquee.nextElementSibling !== productSection) {
      marquee.insertAdjacentElement('afterend', productSection);
    }
  }

  document.addEventListener('DOMContentLoaded', placeJugreHomeProducts);
  document.addEventListener('shopify:section:load', placeJugreHomeProducts);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
